import { THEME_STORAGE_KEY } from '../../constants';
import { useLocalStorageState } from '../../hooks';
/**
 * Hook to get the theme key from local storage.
 */
export const useLocalStorageThemeKey = () => {
    return useLocalStorageState(THEME_STORAGE_KEY, 'AUTO');
};
